<template>
  <div class="search__tabs">
    <div class="st-tabs" data-tabs="st-content">
      <div class="st-tabs__item active">Товары (<span>{{ products["COUNT"] }}</span>)</div>
      <div class="st-tabs__item">Полезные статьи (<span>{{ articles["COUNT"] }}</span>)</div>
      <div class="st-tabs__item">Другое (<span>{{ other["COUNT"] }}</span>)</div>
    </div>

    <div class="st-content">

      <div class="st-content__item active">
        <div v-if="products['COUNT'] > 0" class="product-list">
          <catalog-item v-for="item in products['ITEMS']" :key="item.ID" :info="item" :marketplaces="item.MARKETPLACES"></catalog-item>
        </div>
      </div>

      <div class="st-content__item">
        <div class="articles__list">
          <div v-if="articles['COUNT'] > 0" class="articles-items">
            <a v-for="(article, index) in articles['ITEMS']" :key="index" class="article-item" :href="article['URL']">
              <div class="article-item__img">
                <picture>
                  <source media="(min-width: 768px)" :srcset="article['PICTURE'] ? article['PICTURE']['src'] : ''">
                  <source media="(max-width: 767px)" :srcset="article['PICTURE_MOBILE'] ? article['PICTURE_MOBILE']['src'] : ''">
                  <img alt="Изображение" loading="lazy">
                </picture>
              </div>
              <div class="article-item__title">{{ article["TITLE"] }}</div>
              <div class="article-item__bottom">
                <div v-for="(tag, index) in article['TAGS']" :key="index" class="article-item__bottom-section">{{ tag }}
                </div>
                <div class="article-item__bottom-date">{{ article["DATE"] }}</div>
              </div>
            </a>
          </div>
          <p v-else>По вашему запросу статей не найдено.</p>
        </div>
      </div>

      <div class="st-content__item">
        <div v-if="other['COUNT'] > 0" class="product-list product-list--1">
          <div v-for="(otherItem, index) in other['ITEMS']" :key="index" class="product-card">
            <a class="product-card__link" :href="otherItem['URL']"></a>
            <div class="product-card__title">{{ otherItem["TITLE"] }}</div>
            <div class="product-card__description" v-html="otherItem['BODY_FORMATED']"></div>
          </div>
        </div>
        <p v-else>По вашему запросу других материалов не найдено.</p>
      </div>
    </div>
    <div v-if="!all" @click="loadMore" class="btn">Загрузить еще</div>
  </div>
</template>

<script>
import CatalogItem from "@/components/Catalog/CatalogItem";

export default {
  name       : "SearchResult",
  components : {CatalogItem},
  props      : {
    search_result : Object,
    query_prop    : String,
    pages         : Number,
    nav_num       : Number
  },
  data()
  {
    return {
      query    : "",
      page     : 2,
      all      : false,
      products : {
        ITEMS : [],
        COUNT : 0
      },
      articles : {
        ITEMS : [],
        COUNT : 0
      },
      other    : {
        ITEMS : [],
        COUNT : 0
      }
    };
  },
  methods : {
    loadMore()
    {
      if(this.all) return;
      let query = (document.location.search === "" ? "?" : "&") + "pagination=Y&PAGEN_" + this.nav_num + "=" + this.page;
      fetch(document.location.href + query, {
        method : "GET"
      })
      .then(response => response.json())
      .then(result =>
      {
        if(result.data)
        {
          this.products["COUNT"] += parseInt(result.data["PRODUCTS"]["COUNT"]);
          this.articles["COUNT"] += parseInt(result.data["ARTICLES"]["COUNT"]);
          this.other["COUNT"] += parseInt(result.data["OTHER"]["COUNT"]);
          if(result.data["PRODUCTS"]["ITEMS"])
          {
            for(let key in result.data["PRODUCTS"]["ITEMS"])
              this.products["ITEMS"].push(result.data["PRODUCTS"]["ITEMS"][key]);
          }
          if(result.data["ARTICLES"]["ITEMS"])
          {
            for(let key in result.data["ARTICLES"]["ITEMS"])
              this.articles["ITEMS"].push(result.data["ARTICLES"]["ITEMS"][key]);
          }
          if(result.data["OTHER"]["ITEMS"])
          {
            for(let key in result.data["OTHER"]["ITEMS"])
              this.other["ITEMS"].push(result.data["OTHER"]["ITEMS"][key]);
          }
        }
        this.page++;
        if(this.pages < this.page)
        {
          this.all = true;
        }
      });
    }
  },

  created()
  {
    this.all               = this.pages < this.page;
    this.query             = this.query_prop;
    this.products["COUNT"] = this.search_result["PRODUCTS"]["COUNT"];
    this.articles["COUNT"] = this.search_result["ARTICLES"]["COUNT"];
    this.other["COUNT"]    = this.search_result["OTHER"]["COUNT"];
    if(this.search_result["PRODUCTS"]["ITEMS"])
    {
      for(let key in this.search_result["PRODUCTS"]["ITEMS"])
        this.products["ITEMS"].push(this.search_result["PRODUCTS"]["ITEMS"][key]);
    }
    if(this.search_result["ARTICLES"]["ITEMS"])
    {
      for(let key in this.search_result["ARTICLES"]["ITEMS"])
        this.articles["ITEMS"].push(this.search_result["ARTICLES"]["ITEMS"][key]);
    }
    if(this.search_result["OTHER"]["ITEMS"])
    {
      for(let key in this.search_result["OTHER"]["ITEMS"])
        this.other["ITEMS"].push(this.search_result["OTHER"]["ITEMS"][key]);
    }
  }

};
</script>

<style scoped>

</style>